import React from 'react';
import {makeStyles} from '@mui/styles';
import PasswordTextField from "../general/inputs/PasswordTextField";
import {makeRequest} from "../../services/requestService";
import {API_URL} from "../../constants";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import PropTypes from "prop-types";
import {Button, Container, CssBaseline, Grid, Link, TextField, Typography} from "@mui/material";


const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Register(props) {
    const {onClickLogin} = props;
    const classes = useStyles();
    const {t} = useTranslation('common');
    const {enqueueSnackbar} = useSnackbar();
    const [pseudo, setPseudo] = React.useState("");
    const [username, setUsername] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");


    const onChangePseudo = (e) => {
        const pseudo = e.target.value;
        setPseudo(pseudo);
    };

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
    };

    const onChangeEmail = (e) => {
        const email = e.target.value;
        setEmail(email);
    };

    const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
    };

    const handleRegister = (e) => {
        e.preventDefault();
        makeRequest(`${API_URL}/auth/register`, 'POST', {pseudo, username, email, password})
            .then((response) => {
                if (response.status === 201) {
                    enqueueSnackbar(response.data.message, {variant: "success"});
                    onClickLogin();
                }
            });
    }

    const goToLogin = (e) => {
        e.preventDefault();
        onClickLogin();
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    {t('main.components.auth.register')}
                </Typography>
                <form onSubmit={handleRegister} className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                color="secondary"
                                name="pseudo"
                                variant="outlined"
                                required
                                fullWidth
                                id="pseudo"
                                label={t('main.components.form.placeholder.pseudo')}
                                onChange={onChangePseudo}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                required
                                fullWidth
                                id="username"
                                label={t('main.components.form.placeholder.username')}
                                name="username"
                                autoComplete="username"
                                onChange={onChangeUsername}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label={t('main.components.form.placeholder.email')}
                                type="email"
                                name="email"
                                autoComplete="email"
                                onChange={onChangeEmail}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordTextField
                                label={t('main.components.form.placeholder.password')}
                                value={password}
                                onChange={onChangePassword}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                {t('main.components.button.register')}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <Link href="#" onClick={goToLogin} variant={"body2"} color="textSecondary">
                                        {t('main.components.auth.haveAccount')}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Container>
    );
}

Register.propTypes = {
    onClickLogin: PropTypes.func.isRequired
}